<template>
    <header class="header">
        <div class="header__image" >
            <router-link :to="{name: 'profile'}">
                <img src="@/assets/images/logo.svg" alt="" />
            </router-link>
        </div>

        <img @click="openMenu" class="header__profile" id="profile_photo" src="@/assets/icons/black-menu.svg"/>

    </header>
    <div class="header-overlay"></div>

    <div class="wrapper">
        <Menu></Menu>
        <vue-basic-alert ref="alert" />
        <router-view />
    </div>
</template>

<script>
import {ref, provide} from "vue";
import Menu from "@/components/Menu";
import VueBasicAlert from "vue-basic-alert";
import {useAuthStore} from "@/stores/auth.store";
import { useMenuStore } from "@/stores/menu.store";

export default {
    name: "UserLayout",
    components: {Menu, VueBasicAlert},
    setup() {
        const alert = ref();
        provide('alert', alert);
        const userStore = useAuthStore();
        const menuStore = useMenuStore()

        const openMenu = () => {
            menuStore.isOpen = !menuStore.isOpen;
        }

        return {
            openMenu,
            alert,
            userStore
        }
    }
}
</script>

<style scoped lang="scss">
.header{
    &__profile {
        object-fit: cover;
    }
}

@media screen and (max-width: 767px) {
    .header__profile {
        object-fit: contain;
        border-radius: 0;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
}
</style>